<template>
  <div class="modal fade" :id="modalId" tabindex="-1" :data-bs-backdrop="isStatic ? 'static' : 'dynamic'">
    <div class="modal-dialog modal-dialog-centered" :class="modalClass ?? null">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer justify-content-center gap-2" v-if="!noOperation">
          <a type="button" class="c-btn-primary-light" data-bs-dismiss="modal">لغو</a>
          <button type="button" class="c-btn-primary" @click="$emit('save')">ذخیره</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
    modalClass: {
      type: String,
      required: false,
    },
    noOperation: {
      type: Boolean,
      default: false
    },
    isStatic: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style scoped>
.modal-body {
  max-height: 30vw;
  overflow-y: auto;
}
</style>
